import { configureStore } from "@reduxjs/toolkit";
import timerReducer from ".././reducers/counter";
import websocketReducer from "../reducers/topic";
import authReducer from ".././reducers/auth";

export const store = configureStore({
  reducer: {
    timer: timerReducer,
    websocket: websocketReducer,
    auth: authReducer,
  },
  devTools: true,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
